import { useMemo, useState, useContext, useEffect, Fragment } from 'react'
import { Badge, Button, Col, Container, Dropdown, Form, Row, Stack } from 'react-bootstrap'
import { useLocation, useNavigate } from 'react-router-dom'
import { useTable } from 'react-table'
import { KTCardBody, KTIcon } from '../../../../../_metronic/helpers'
import { useQueryResponseData } from '../../../apps/user-management/users-list/core/QueryResponseProvider'
import { usersColumns } from '../../../apps/user-management/users-list/table/columns/_columns'
import { showMessage } from '../../../../shared/Alerts'
import { PartnerContext } from '../PartnerContexts'
import { TipoDocument } from '../tipodocumentInterface'
import { crearRolData, updateRolData } from '../../../../services/rol'
import ReactQuill from 'react-quill'
import { crearTipoDocumentData, updateTipoDocumentData } from '../../../../services/tipodocument'

const DataTipoDocument:TipoDocument = {
  _id:'', 
  nombre: '',
  descripcion: '',
  id_empresa: '',
  estado: true
}

const TipoDocumentFomulario = () => {
  const {tipoDocumentData,setTipoDocumentData,edit,setEdit,setReloadTable} = useContext(PartnerContext)
  const [loading, setLoading] = useState(false)
  const [editButton, setEditButton] = useState(false); 
  const [tipodDocument, setTipoDocument] = useState<TipoDocument>(tipoDocumentData)
  const [bodyValue, setBodyValue] = useState('')

  useEffect(() => {
    setTipoDocument(tipoDocumentData)
  }, [tipoDocumentData])

  
  useEffect(() => {
    setEditButton(edit)
  }, [edit])
  
  

  const handleChange = (e: any) => {
      setTipoDocument({...tipodDocument, [e.target.name]: e.target.value})
  }

  const clear = ()=>{
    setEdit(false)
    setTipoDocumentData(DataTipoDocument)
    setBodyValue("")
  }


  const handleSubmit = (e: any) => {
    e.preventDefault()
    const data = {...tipodDocument, contenido: bodyValue}
    if (data._id === "") {      
      setLoading(true)
      crearTipoDocumentData(data)
      .then((response) => {
        setTipoDocumentData(DataTipoDocument)
        if (response.success) {          
          setReloadTable(true)
          showMessage("success","Agregado",response.message)
          setLoading(false)
        } else {
          setLoading(false)
          showMessage("error","Hubo un error",response.message)
          console.log(response)
        }
      })
      .catch((error) => {
        setLoading(false)
        showMessage("error","Hubo un error",error.message)
        console.log(error)
      })
    }else{
      setLoading(true)
      updateTipoDocumentData(data._id,data)
      .then((response) => {
        setTipoDocumentData(DataTipoDocument)
        if (response.success) {
          setReloadTable(true)
          showMessage("success","Actualizado",response.message)
          setEdit(false)
          setLoading(false)
        } else {
          setLoading(false)
          showMessage("error","Hubo un error",response.message)
          console.log(response)
        }
      })
      .catch((error) => {
        setLoading(false)
        console.log(error)
      })
    }
  }

  return (
    <>
      <KTCardBody className='py-4'>
        <div className="card-header">
            <h3 className="card-title">Tipo Documento</h3>
        </div>
        <Container>          
          <Row className='row mb-3 pt-3 px-3' >
            <Form onSubmit={handleSubmit}>
              <Col sm className='mb-2'>
                <Form.Group controlId='formNombre'>
                  <Form.Label>Nombre</Form.Label>
                  <Form.Control
                    type='text'
                    className='form-control-sm'                      
                    required
                    value={tipodDocument.nombre}
                    placeholder='Ingrese titulo'
                    onChange={handleChange}  
                    name='nombre'
                  />
                </Form.Group>
              </Col>
              <Col sm className='mb-2'>
                <Form.Group controlId='formNombre'>
                  <Form.Label>Descripcion</Form.Label>
                  <Form.Control
                    type='text'
                    className='form-control-sm'                      
                    value={tipodDocument.descripcion}
                    placeholder='Ingrese descripcion'
                    onChange={handleChange}  
                    name='descripcion'
                  />
                </Form.Group>
              </Col>
              <Row style={{marginTop:'30px'}}>                
                <Col>
                  <div className='d-flex justify-content-end'>
                    {!loading && editButton &&                       
                      <Button className='mx-2' variant='light' 
                      type='reset' 
                      onClick={() => {
                        clear()
                      }}>
                        Cancelar
                      </Button>
                    }
                    <Button variant='success' type='submit'>
                      {!loading && !editButton && 'Registrar'}
                      {!loading && editButton && 'Actualizar'}
                      {loading && (
                        <span className='indicator-progress' style={{display: 'block'}}>
                          Subiendo...{' '}
                          <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                        </span>
                      )}
                    </Button>
                  </div>
                </Col>
              </Row>
            </Form>
          </Row>
        </Container>
      </KTCardBody>
    </>
  )
}

export { TipoDocumentFomulario }
